/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import { FormattedMessage } from 'react-intl';
import OtherSettingsForm from './components/OtherSettingsForm';
import useTemplatesOtherConfigs from '../../../hooks/Barcode/useTemplatesOtherConfigs';

function OtherSettings() {
  const { templatesSettings, isLoading, configId } = useTemplatesOtherConfigs();

  const [initialValues, setInitialValues] = useState({});
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  useEffect(() => {
    // Default values organized by categories
    const defaultValues = {
      basicSettings: {
        allowCreateEmptyInstance: true,
        allowImportEmptyInstance: true,
        firstItemLoanPolicy: '',
        enableRecordLocking: true,
      },
      volumeManagement: {
        enableVolumeManagement: true,
        volumeManagementModeOfIssuance: [],
      },
      classification: {
        libraryClassificationTypes: [],
        preferredClassificationType: '',
      },
      authority: {
        enabledAuthorityFields: [],
        enableAutoCreateAuthority: true,
        enableAutoLinking: true,
        sources: {
          personalNameAuthoritySource: '',
          corporateNameAuthoritySource: '',
          conferenceNameAuthoritySource: '',
          uniformTitleAuthoritySource: '',
          topicalSubjectAuthoritySource: '',
        },
      },
    };

    if (templatesSettings) {
      // Merge existing settings with defaults for new fields
      setInitialValues({
        ...defaultValues,
        ...templatesSettings, // Existing settings override defaults
      });
    } else {
      // Use all default values for new configurations
      setInitialValues(defaultValues);
    }
  }, [templatesSettings]);

  const onHandleSubmit = (values) => {
    if (configId) {
      okapiKy
        .put(`inventory-templates-configs/${configId}`, {
          timeout: 30000,
          method: 'PUT',
          json: {
            id: configId,
            configName: 'templatesSettings',
            configCode: 'templatesSettings',
            configValue: values,
          },
        })
        .then((res) => {
          if (res.ok) {
            setInitialValues(values);
            const message = (
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesSettings.callout.updated"
                defaultMessage="Templates settings updated successfully"
              />
            );
            context.sendCallout({ message, type: 'success' });
          }
        })
        .catch(async (err) => {
          console.log(err);
          const res = err.response;
          const text = await res.text();
          console.log(text);
          context.sendCallout({ message: text, type: 'error' });
        });
    } else {
      okapiKy
        .post('inventory-templates-configs', {
          timeout: 30000,
          method: 'POST',
          json: {
            configName: 'templatesSettings',
            configCode: 'templatesSettings',
            configValue: values,
          },
        })
        .then((res) => {
          if (res.ok) {
            setInitialValues(values);
            const message = (
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesSettings.callout.created"
                defaultMessage="Templates settings created successfully"
              />
            );
            context.sendCallout({ message, type: 'success' });
          }
        })
        .catch(async (err) => {
          console.log(err);
          const res = err.response;
          const text = await res.text();
          console.log(text);
          context.sendCallout({ message: text, type: 'error' });
        });
    }
  };

  return (
    <OtherSettingsForm
      initialValues={initialValues}
      onHandleSubmit={onHandleSubmit}
      isLoading={isLoading}
    />
  );
}

export default OtherSettings;
